const borders = {
  none: 0,
  "ms-1": "1px solid",
  "ms-2": "2px solid",
  "ms-4": "4px solid",
  "ms-8": "8px solid",
};

export default borders;
